import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon74: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 20" width={width} height={height} {...props}>
      <Path
        d="M13.5 0C15.54 0 17.223 1.527 17.469 3.5H19.5C19.776 3.5 20 3.724 20 4V9C20 9.276 19.776 9.5 19.5 9.5H19V16.183C19 18.246 17.116 19.894 14.784 19.992L14.564 19.997H11.53L11.5 20H8.5C8.49 20 8.47997 20 8.46997 19.999L5.43597 19.997C3.00297 19.997 1 18.31 1 16.183V9.5H0.5C0.255 9.5 0.0499956 9.323 0.00799561 9.09L0 9V4C0 3.724 0.224 3.5 0.5 3.5H2.53101C2.77701 1.527 4.46 0 6.5 0C8.007 0 9.31898 0.833002 10.001 2.065C10.681 0.833002 11.993 0 13.5 0ZM8 9.5H2V16.183C2 17.716 3.52097 18.997 5.43597 18.997H8V9.5ZM11 4.5H9V18.997H11V4.5ZM18 9.5H12V18.997H14.564C16.413 18.997 17.895 17.803 17.995 16.341L18 16.183V9.5ZM19 4.5H12V8.5H19V4.5ZM8 4.5H1V8.5H8V4.5ZM9.45898 3.5C9.22098 2.081 7.987 1 6.5 1C5.013 1 3.77902 2.081 3.54102 3.5H9.45898ZM13.5 1C12.013 1 10.779 2.081 10.541 3.5H16.459C16.221 2.081 14.987 1 13.5 1Z"
        fill="#404040"
      />
    </Icon>
  )
}
